function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { ComponentBootstrap } from '@demant/react-bootstrap';
import flexSpotSchema from '@demant/react-bootstrap/lib/schemas/flex-spot';
import BrainHearingComponent from './js/brain-hearing-lp';
var footerGlobalData;
var isScrolled;
var FlexSpotReactComponent = function FlexSpotReactComponent(_ref) {
  var settings = _ref.settings,
    component = _ref.component;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    footerData = _useState2[0],
    setFooterData = _useState2[1];
  var setLoading = function setLoading(element) {
    element.setAttribute('src', element.getAttribute('data-src'));
  };
  var _deferIForElements = function deferIForElements() {
    isScrolled = true;
    window.removeEventListener('scroll', _deferIForElements);
    var iframeElem = document.querySelectorAll('[data-src]');
    for (var i = 0; i < iframeElem.length; i++) {
      if (iframeElem[i].getAttribute('data-src')) {
        setLoading(iframeElem[i]);
      }
    }
  };
  useEffect(function () {
    if (footerData) {
      footerGlobalData = footerData;
    } else if (footerGlobalData != footerData) {
      setFooterData(footerGlobalData);
    }
  }, [footerData]);
  useEffect(function () {
    if (!isScrolled) {
      setTimeout(function () {
        !isScrolled ? _deferIForElements() : null;
      }, 6000);
      window.addEventListener('scroll', _deferIForElements);
      return function () {
        window.removeEventListener('scroll', _deferIForElements);
      };
    }
  }, []);
  return /*#__PURE__*/React.createElement(BrainHearingComponent, {
    settings: settings,
    component: component,
    setFooterData: setFooterData,
    footerData: footerData
  });
};
var c = new ComponentBootstrap('.flex-spot.general-brainhearing');
c.schemaData = flexSpotSchema;
c.reactApp = FlexSpotReactComponent;
c.onResize = function (component) {
  component.style.display = 'block';
};
c.run();